import { gql } from '@apollo/client';

export const getUsersWhoLikedCommentByCommentIdQuery = gql`
  query getUsersWhoLikedCommentByCommentId($commentId: ID!) {
    comment(where: { id: $commentId }) {
      likes {
        id
        profileImage {
          id
          publicUrl
          publicUrlTransformed
          _meta {
            public_id
            height
            width
          }
        }
        name
        publicAddress
        username
      }
      article {
        territory {
          id
        }
      }
    }
  }
`;
